import { useCallback } from 'react';
import { Container, Row, Col, Label, Button } from '@polichat/flamboyant';
import './details.css';
import { timeHasPassed, transformValueToMonetary } from './functions';
import NewOpportunity from './NewOpportunity.jsx';
import getUrlViewCrm from '../../../../tools/integrations/crmRequests/getUrlViewCrm';
import { useFlags } from 'flagsmith/react'
import { customUseFlags } from 'src/hooks/customUseFlags';

export function Opportunities(props) {
  const flag = useFlags(['embed_crm_details'])
  const embed_crm_details = customUseFlags(flag.embed_crm_details);
  const getUrl = async () => {
    const response = await getUrlViewCrm();

    if (response && response.data) {
      return response.data;
    }
  };
  const getUrlCreateNew = useCallback(async (id) => {
    const url = (await getUrl()) + '?type=opportunity&id=' + id;
    window.open(url, '_blank');
  }, []);

  const handleCallEmbed = () => {
    if(props.isOpen) props.toggleOpportunities();
    props.openEmbedModal('opportunities');
  }

  const getUrlOpportunity = useCallback(async () => {
    const url = await getUrl() + '?type=opportunity';
    window.open(url, '_blank');
  }, []);

  const opportunities = props.opportunities;

  const boxOpportunity = (opportunity) => {
    return (
      <div
        key={opportunity.id}
        className="opportunity-item"
        onClick={() => getUrlCreateNew(opportunity.id)}
      >
        <p className="opportunity-title">{opportunity.title}</p>
        {opportunity.value ? (
          <p className="unique-value">
            {transformValueToMonetary(opportunity.value)}
          </p>
        ) : (
          ''
        )}
        <p className="responsible darkmode">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="16"
            viewBox="0 0 22 16"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.406 1.14471C16.011 1.14811 16.59 1.39081 17.0166 1.81979C17.4431 2.24876 17.6826 2.82913 17.6826 3.4341C17.6842 3.73317 17.6258 4.02953 17.5109 4.30567C17.3961 4.58181 17.227 4.83212 17.0138 5.04181C16.8032 5.2539 16.5527 5.4222 16.2768 5.53699C16.0008 5.65178 15.7049 5.71079 15.406 5.71062C14.8302 5.66737 14.2919 5.40807 13.8991 4.9847C13.5064 4.56133 13.2881 4.00516 13.2881 3.42766C13.2881 2.85017 13.5064 2.294 13.8991 1.87063C14.2919 1.44726 14.8302 1.18796 15.406 1.14471ZM15.406 1.61776e-05C14.6151 0.00244857 13.8493 0.27889 13.2392 0.782298C12.6291 1.28571 12.2123 1.98497 12.0596 2.7611C11.907 3.53723 12.028 4.34227 12.4021 5.03922C12.7762 5.73616 13.3802 6.28195 14.1114 6.5837C14.8426 6.88546 15.6557 6.92453 16.4125 6.69428C17.1692 6.46402 17.8228 5.97866 18.262 5.3208C18.7012 4.66293 18.8988 3.87321 18.8213 3.08602C18.7438 2.29883 18.396 1.56282 17.8369 1.00323C17.5179 0.683935 17.1389 0.43091 16.7217 0.258733C16.3045 0.0865552 15.8574 -0.00137172 15.406 1.61776e-05ZM8.13566 7.01476C8.77023 6.36579 9.12519 5.49396 9.12439 4.5863C9.12067 3.68464 8.76604 2.81986 8.13566 2.17518C7.48948 1.53426 6.61731 1.17293 5.70719 1.1691C5.25852 1.16759 4.81408 1.25582 4.40001 1.4286C3.98594 1.60138 3.6106 1.85522 3.29607 2.17518C2.66561 2.82289 2.31284 3.69109 2.31284 4.59497C2.31284 5.49886 2.66561 6.36705 3.29607 7.01476C3.6106 7.33473 3.98594 7.58856 4.40001 7.76134C4.81408 7.93412 5.25852 8.02235 5.70719 8.02084C6.61731 8.01701 7.48948 7.65569 8.13566 7.01476ZM2.23766 9.14822H9.17613C9.77118 9.1528 10.3403 9.3924 10.7595 9.8148C11.1786 10.2372 11.4138 10.8082 11.4138 11.4032V14.7C11.4138 15.4179 10.8318 16 10.1138 16H1.3C0.58203 16 0 15.4179 0 14.7V11.4032C0.00487276 10.806 0.241157 10.234 0.659155 9.80738C1.07833 9.38887 1.64534 9.1521 2.23766 9.14822ZM20.1521 15.2669C20.2577 15.3732 20.4011 15.4333 20.5509 15.4341C20.6273 15.4358 20.7034 15.4221 20.7744 15.3936C20.8454 15.3651 20.9099 15.3226 20.964 15.2685C21.0181 15.2144 21.0607 15.1499 21.0892 15.0789C21.1176 15.0078 21.1314 14.9318 21.1296 14.8553V10.8553C21.1296 10.4854 21.0568 10.1191 20.9152 9.77739C20.7737 9.43565 20.5662 9.12514 20.3046 8.86359C20.0431 8.60203 19.7326 8.39455 19.3908 8.253C19.0491 8.11144 18.6828 8.03859 18.3129 8.03859H13.1682C13.0917 8.03683 13.0157 8.0506 12.9447 8.07906C12.8737 8.10752 12.8092 8.15009 12.7551 8.20419C12.701 8.25829 12.6584 8.3228 12.6299 8.39381C12.6015 8.46483 12.5877 8.54088 12.5895 8.61736C12.5902 8.76716 12.6503 8.91054 12.7567 9.01608C12.8083 9.07386 12.8718 9.11985 12.9428 9.15092C13.0139 9.18199 13.0907 9.19742 13.1682 9.19614H18.3129C18.7519 9.19951 19.172 9.37539 19.4824 9.68582C19.7928 9.99625 19.9687 10.4163 19.9721 10.8553V14.8553C19.9708 14.9328 19.9862 15.0097 20.0173 15.0807C20.0484 15.1517 20.0944 15.2152 20.1521 15.2669Z"
              fill="#606161"
            />
          </svg>

          {opportunity.responsible?.name}
        </p>
        <p className="funnel">
          {opportunity.funnel?.name} | Etapa:{' '}
          {opportunity.funnelStep?.stepNumber}
        </p>
        <p className="createdAt">
          Criado: {timeHasPassed(opportunity.createdAt)}
        </p>
      </div>
    );
  };

  let opportunityList = [];

  if (opportunities && Array.isArray(opportunities) && opportunities?.length) {

    opportunityList = opportunities.map((opportunity) =>
      boxOpportunity(opportunity)
    );
  } else {
    opportunityList.push(<NewOpportunity />);
  }
  return (
    <Container>
      <Row>
        <Col>
          <div>
            <div className="opportunity-list">
              {opportunityList}
              {typeof props.fnSeeMore === 'function' ? (
                <Label className="seeMore" onClick={props.fnSeeMore}>
                  Ver mais
                </Label>
              ) : (
                ''
              )}
                <Button className='btn-new-crm' onClick={() => embed_crm_details ? handleCallEmbed() : getUrlOpportunity()}>Criar oportunidade</Button>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
